export const textToArray = (string = '') => {
  // Split on each new line and filter out empty rows
  const filteredItems = string.split(/\r?\n|\r|\n/g).filter(Boolean) || [];
  // Remove whitespace around items
  return filteredItems.map((item) => item.trim()).filter(Boolean);
};
